import request from '@/utils/request';

const PATH = '/bank/info';

export const getBankInfoListAll = () => request({
  url: PATH,
  method: 'get',
});
